import { Button } from "@/components/ui/button";
import { Check, Loader } from "lucide-react";

export function ActionButtonsContrato({
  navigate,
  isPending,
  submitAction,
  onSave,
  onSend,
}: {
  navigate: (path: string) => void
  isPending: boolean
  submitAction: "save" | "send" | null
  onSave: () => void
  onSend: () => void
}) {
  return (
    <div className="flex items-center gap-4 justify-end pt-2">
      <Button
        type="button"
        variant="destructive"
        size="lg"
        onClick={() => navigate("/contratual/contratos")}
        disabled={isPending}
      >
        Cancelar
      </Button>

      <Button
        type="submit"
        size="lg"
        onClick={onSave}
        disabled={isPending}
        className=""
      >
        {isPending && submitAction === "save" ? (
          <Loader className="w-[20px] h-[20px] animate-spin" />
        ) : (
          <Check className="w-[20px] h-[20px]" />
        )}
        Salvar
      </Button>

      <Button
        variant="secondary"
        size="lg"
        type="button"
        onClick={onSend}
        disabled={isPending}
      >
        {isPending && submitAction === "send" ? (
          <Loader className="w-[20px] h-[20px] animate-spin" />
        ) : (
          <Check className="w-[20px] h-[20px]" />
        )}
        Solicitar
      </Button>
    </div>
  )
}